module.exports = "<p>stacked-area-amchart works!</p>\n"